import Vue from 'vue';
import axios from 'axios';
import VueAxios from 'vue-axios';
import VueRecaptcha from 'vue-recaptcha';
import VueTheMask from 'vue-the-mask';
import Swal from 'sweetalert2';
import VueSweetalert2 from 'vue-sweetalert2';

import ContactosService from '../../../panel/services/ContactosService';

Vue.use(VueAxios, axios);
Vue.use(VueSweetalert2);
Vue.use(VueTheMask);

let app = new Vue({
    el: '#app',
    components: {
        VueRecaptcha,
    },
    data() {
        return {
            loading: false,
            errores: [],
            mensaje_error: 'red',
            form: {
                nombre_apellido: '',
                correo: '',
                telefono: '',
                nombre_empresa: '',
                mensaje: '',
                'g-recaptcha-response': '',
            }
        };
    },
    methods: {
        captchaErrored() {
            this.form['g-recaptcha-response'] = '';
            this.$refs.recaptcha.reset();
        },
        captchaExpired() {
            this.form['g-recaptcha-response'] = '';
        },
        captchaVerify(res) {
            this.form['g-recaptcha-response'] = res;
            console.log(res);
        },
        mensaje(tipo, titulo, mensaje) {
            this.$swal.fire({
                icon: tipo,
                title: titulo,
                text: mensaje,
                showCloseButton: true,
                showConfirmButton: true,
                cancelButtonText: 'Cancelar',
                confirmButtonText: 'Aceptar',
            });
        },
        async enviar() {
            try {
                this.loading = true;

                const response = await ContactosService.addAyuda(this.form);

                this.form.nombre_apellido = '';
                this.form.correo = '';
                this.form.telefono = '';
                this.form.nombre_empresa = '';
                this.form.razon_social = '';
                this.form.mensaje = '';
                this.form['g-recaptcha-response'] = '';
                this.errores = [];

                this.loading = false;

                this.mensaje("success", "Bien", response.success);

                window.gtag('event', 'generate_lead', {
                    event_category: 'formulario',
                    event_label: 'ayuda',
                });
                window.fbq('track', 'Contact');

            } catch (error) {
                this.loading = false;
                this.form['g-recaptcha-response'] = '';
                this.errores = error.errors;
                this.mensaje("error", "Error", "Disculpe, verifique los datos ingresados.");
            } finally {
                this.loading = false;
            }
        },
    },
});
